import type { TSetTranslationKeys } from '@crehana/ts-types';

import type localeEs from './i18n/localeEs';

export interface IAppProps {
  pageUrl?: string;
}

export type UserDashboardLocaleKeys = TSetTranslationKeys<typeof localeEs>;

// FRONT-188: kept as hardcoded literals on purpose — do NOT derive from
// `typeof PLAYER_URL_SOURCES`. PLAYER_URL_SOURCES lives in ./constants, and ./constants
// already imports FaqType/StudentType from this file; deriving the type from it here would
// re-create the constants <-> types circular dependency this refactor removed. Keep these
// 4 values in sync with PLAYER_URL_SOURCES (constants.tsx) by hand.
export type UserDashboardPlayerUrlSource =
  | 'Track Card'
  | 'Bundle Card'
  | 'Career Card'
  | 'MicroDegree Detail';

export type FaqType = {
  key: string;
  href: string;
  text: UserDashboardLocaleKeys;
};

export enum StudentTypeEnum {
  PAYG = 'payg',
  B2B = 'b2b',
  DEGREE = 'degree',
  PREMIUM = 'premium',
  PREMIUM_TRIAL = 'premium-trial',
  REGISTER = 'register',
}

export type StudentType =
  | 'degree'
  | 'b2b'
  | 'premium'
  | 'premium-trial'
  | 'register'
  | 'payg';
